import charts from "surveylabJsAssets/chart/charts";

export default function () {
    $(function () {
        charts();
    });
}
